const mEditionAssetActivationCalendar = {
  mEditionAssetActivationCalendar: {
    alerts: {
      calendar: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Los días de entrega fueron editados exitosamente.'
      },

      updateContenidoActivarNodos: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Los días de entrega fueron editados exitosamente.'
      }
    },

    buttonPrimary: {
      nodo: 'GUARDAR'
    },

    messages: {
      activeOne: 'La activación de cada contenido se realizará tomando en cuenta la fecha de inicio del curso',
      activeZero: 'La activación de cada contenido se realizará tomando en cuenta la fecha de inscripción del alumno + el día de entrega.',
      selectionContent: 'Selecciona el contenido y luego selecciona una fecha en el calendario.'
      // activeOne: 'La activación de cada contenido se realizará tomando en cuenta el día de entrega + la fecha de inicio del curso',
      // activeZero: 'La activación de cada contenido se realizará tomando en cuenta la fecha de inscripción del alumno + el día de entrega.'
    },

    titles: {
      days: 'Configura los días de entrega para tus contenidos'
    }
  }
}

export default mEditionAssetActivationCalendar
